import { PRIMITIVE_REFS, SEMANTICS_SRC, } from './index';
function isLiteral(v) {
    return typeof v === 'object' && v !== null && '$value' in v;
}
/**
 * Resolve a semantic token to its concrete value for the given mode. A mode value
 * is either a raw literal (passed through) or a primitive reference (looked up in
 * PRIMITIVE_REFS).
 */
export function resolve(path, mode) {
    const token = SEMANTICS_SRC[path];
    if (!token)
        throw new Error(`Unknown semantic token: ${path}`);
    const value = token[mode];
    if (isLiteral(value))
        return value.$value;
    const concrete = PRIMITIVE_REFS[value];
    if (concrete === undefined) {
        throw new Error(`Unknown primitive reference: ${String(value)} (from ${path})`);
    }
    return concrete;
}
//# sourceMappingURL=resolve.js.map